// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_jkx","cls2":"ClaimEvaluationRow-cls2_sAW ClaimEvaluationRow-cls1_jkx"};